import React, {
    ReactElement,
} from "react";

import {
    ChatSettingsDeflection,
} from "../../../../../__generated__/api";
import { ProxyProperty } from "../../../../../components/dirty-tracker/FormTracker";
import DeflectionSource from "../../../../../components/pickers/deflection-sources/DeflectionSource";
import SettingsContainer from "../../../../../components/theme/settings";

export interface Props {
    data: ProxyProperty<ChatSettingsDeflection>,
}

export default function DeflectionSettings({ data }: Props): ReactElement {
    const properties = data.useBuilder(
        builder => builder
            .property("identity", parent => parent?.identity)
            .property("isEnabled", parent => parent?.isEnabled),

    );

    return (

        <SettingsContainer.Section
            title="Deflection"
            helpText="By enabling Deflection, your customers can receive instant answers to their
                questions through AI-powered responses using your existing knowledge base. This feature
                acts as a first line of help, aiming to resolve queries quickly and reduce wait times
                for your customers. If the immediate response isn't sufficient, the query will seamlessly
                transfer to a human agent. This way, your team focuses more on complex issues, enhancing
                efficiency. You'll also gain insights from deflection results in your reports, helping
                you understand common queries and refine your knowledge base over time."
        >
            <SettingsContainer.Setting
                title="Deflection Source"
                description="Should the deflection will be enabled in this channel. If so, what should be the source?"
                permissions={SettingsContainer.Setting.Permissions.GroupAdministrator}
            >
                <DeflectionSource
                    className={SettingsContainer.Setting.PickerClassName}
                    onSelected={value => {
                        properties.identity.setValue(value);
                        properties.isEnabled.setValue(value != null);
                    }}
                    value={properties.identity.value}
                />
            </SettingsContainer.Setting>

        </SettingsContainer.Section>

    );
}

DeflectionSettings.defaultProps = {
};
